import useNewsTipBaseActions from './useNewsTipBaseActions'

export default useNewsTipBaseActions
